(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ScheduleInfoCustom', ScheduleInfoCustom);

    ScheduleInfoCustom.$inject = ['$resource', 'DateUtils'];

    function ScheduleInfoCustom($resource, DateUtils) {


        var primaryScheduleInfosByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/primary-schedule-info-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var primaryScheduleInfosByCompany = function (companyId) {
            var resourceUrl = 'api/schedule-info-by-company/' + companyId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getDynamicAvailableDatesByServiceId = function (serviceId) {
            var resourceUrl = 'api/get-dynamic-available-dates-by-service-id?serviceId=' + serviceId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getDynamicAvailableTimesByServiceIdInOneDate = function (serviceId, date) {
            var resourceUrl = 'api/get-dynamic-available-times-by-service-id-in-one-date?serviceId=' + serviceId + '&dateTimeStr=' + date;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getDynamicAvailableDatesByServiceIdAndServantId = function (serviceId, servantId, fromDate, toDate) {
            var resourceUrl = 'api/get-available-dates-by-service-servant?';
            if (serviceId)
                resourceUrl += 'serviceId=' + serviceId;
            if (servantId && servantId != null)
                resourceUrl += '&servantid=' + servantId;
            if (fromDate)
                resourceUrl += '&fromDate=' + DateUtils.convertToISOString(fromDate);
            // else
            //     resourceUrl+= '&fromDateToLoad='+0;

            if (toDate)
                resourceUrl += '&toDate=' + DateUtils.convertToISOString(toDate);
            // else
            //     resourceUrl+= '&toDaysToLoad='+180;


            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getDynamicAvailableTimesByServiceIdAndServantIdInOneDate = function (serviceId, servantId, date) {
            var resourceUrl = 'api/get-available-times-by-service-servant-in-one-date?serviceId=' + serviceId + '&dateTimeStr=' + date;
            if (servantId)
                resourceUrl += '&servantid=' + servantId;

            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getCurrentScheduleInfoByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/get-current-schedule-info-by-service-item-id?serviceId=' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getDynamicAvailableMonthlyDatesByServiceId = function (serviceId) {
            var resourceUrl = 'api/get-dynamic-available-monthly-dates-by-service-id?serviceId=' + serviceId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getDefaultBaseOffDaySchedule = function () {
            var resourceUrl = 'api/get-default-base-off-day-schedule-id';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getAllDate = function (fromDate, toDate) {
            var resourceUrl = 'api/get-all-dates?';

            if (fromDate)
                resourceUrl += '&fromDate=' + DateUtils.convertToISOString(fromDate);

            if (toDate)
                resourceUrl += '&toDate=' + DateUtils.convertToISOString(toDate);

            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var getServantExceptionDurationsByServantId = function (servantId, availabilityMode) {
            var resourceUrl = 'api/get-servant-exception-durations-by-servant-id?servantId=' + servantId + '&availabilityMode=' + availabilityMode;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        return {
            primaryScheduleInfosByServiceItem: primaryScheduleInfosByServiceItem,
            primaryScheduleInfosByCompany: primaryScheduleInfosByCompany,
            getDynamicAvailableDatesByServiceId: getDynamicAvailableDatesByServiceId,
            getDynamicAvailableTimesByServiceIdInOneDate: getDynamicAvailableTimesByServiceIdInOneDate,
            getCurrentScheduleInfoByServiceItem: getCurrentScheduleInfoByServiceItem,
            getDynamicAvailableMonthlyDatesByServiceId: getDynamicAvailableMonthlyDatesByServiceId,
            getDynamicAvailableDatesByServiceIdAndServantId: getDynamicAvailableDatesByServiceIdAndServantId,
            getDynamicAvailableTimesByServiceIdAndServantIdInOneDate: getDynamicAvailableTimesByServiceIdAndServantIdInOneDate,
            getDefaultBaseOffDaySchedule: getDefaultBaseOffDaySchedule,
            getAllDate: getAllDate,
            getServantExceptionDurationsByServantId: getServantExceptionDurationsByServantId
        };
    }
})();
